import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import RadioButtonGroupContext from './radio-button-group/radio-button-group.context';

/**
 * @typedef Props
 * @prop {React.ReactChildren} children
 * @prop {string} [className]
 * @prop {boolean} [disabled]
 * @prop {string} [name]
 * @prop {boolean} [required]
 * @prop {boolean} [checked]
 * @prop {string} [id]
 * @prop {() => void} [onChange]
 * @prop {boolean} [required]
 * @prop {string} [value]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifRadioButton = (props) => {
  const {
    checked = false,
    children,
    className = '',
    disabled = false,
    id = '',
    name = '',
    onChange = () => null,
    required = false,
    value = '',
    ...other
  } = props;
  const radioButtonGroupContext = useContext(RadioButtonGroupContext);
  const classes = classNames({
    'motif-radio-button': true,
    'motif-disabled': radioButtonGroupContext.groupDisabled || disabled,
    'motif-radio-button-in-group': radioButtonGroupContext.isGroup,
    [className]: true
  });

  const renderRadioSVG = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width="20"
      height="20"
      className="motif-radio-button-custom"
    >
      <path
        className="motif-radio-button-border"
        d="M256 34.4c59.6 0 114.5 23.3 156.4 65.2 41.9 41.9 65.2 97.7 65.2 156.4s-23.3 114.5-65.2 156.4c-41.9 41.9-97.7 65.2-156.4 65.2s-114.5-23.3-156.4-65.2S34.4 314.6 34.4 256 57.7 141.5 99.6 99.6 196.4 34.4 256 34.4M256 0C114.5 0 0 114.5 0 256s114.5 256 256 256 256-114.5 256-256S397.5 0 256 0z"
      />
      <path
        className="motif-radio-button-bullet"
        d="M388.2 123.8C352.8 88.4 306.3 68.9 256 68.9s-96.8 19.5-132.2 54.9S68.9 205.7 68.9 256s19.5 96.8 54.9 132.2 81.9 54.9 132.2 54.9 96.8-19.5 132.2-54.9 54.9-81.9 54.9-132.2S423.6 159.2 388.2 123.8z"
      />
    </svg>
  );

  return (
    <label className={classes} data-motif-radio-button>
      <input
        {...other}
        className="motif-radio-button-input motif-visually-hidden"
        type="radio"
        checked={checked}
        disabled={radioButtonGroupContext.groupDisabled || disabled}
        id={id}
        name={radioButtonGroupContext.groupName || name}
        required={radioButtonGroupContext.groupRequired || required}
        value={value}
        onChange={onChange}
      />

      {renderRadioSVG}
      <span
        className="motif-radio-button-label"
        aria-disabled={radioButtonGroupContext.groupDisabled || disabled}
      >
        {children}
      </span>
    </label>
  );
};

MotifRadioButton.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  value: PropTypes.string
};

export { MotifRadioButton };
